import cm from 'classnames';
import styles from './_intro.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'small' | 'medium' | 'large';
}

export const IntroWrapper = ({ className, children, size, ...rest }: Props) => {
  return (
    <div
      {...rest}
      className={cm(styles.IntroContent, className, { [styles['IntroContent--medium']]: size === 'medium' })}
    >
      {children}
    </div>
  );
};

export const IntroIFrame = ({ src }: { src: Url }) => {
  // Add quality parameters to YouTube URLs for highest resolution
  const enhancedSrc = src.includes('youtube.com')
    ? `${src}${src.includes('?') ? '&' : '?'}vq=hd1080&modestbranding=1&rel=0`
    : src;

  return (
    <iframe
      width={560}
      height={315}
      src={enhancedSrc}
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};
